export default
{
    computed:
    {
        listedRanges()
        {
            if( !this.ranges )
            {
                return false;
            }

            return Object.keys( this.ranges ).map( value =>
            {
                return (
                {
                    label    : value,
                    value    : this.ranges[ value ],
                    selected : this.$dateUtil.isSame( this.selected.startDate, this.ranges[value][0] ) && this.$dateUtil.isSame( this.selected.endDate, this.ranges[value][1] )
                });
            })
        },

        selectedRange()
        {
            return this.listedRanges.find( r => r.selected === true )
        },

        showCustomRangeLabel()
        {
            return !this.alwaysShowCalendars;
        }
    }
}